export default __webpack_public_path__ + "static/media/Exclamation.973f3e38.svg";